import SourceFlowText from "@sourceflow-uk/sourceflowtext";
import SourceFlowForm from '@sourceflow-uk/sourceflowform';
import jobsSector from "../../.sourceflow/jobs-Job Sectors.json";
import ukjobsType from "../../.sourceflow/jobs-Job Types.json";
import usjobsType from "../../.sourceflow/jobs-Job Type US.json";
import ukjobsWorkType from "../../.sourceflow/jobs-Work Type.json";
import usjobsWorkType from "../../.sourceflow/jobs-Work Type US.json";
import jobsCountry from "../../.sourceflow/jobs-Country.json";
import ukbasesalaryrange from "../../.sourceflow/jobs-UK Base Salary Range.json";
import usbasesalaryrange from "../../.sourceflow/us_base_salary_range.json";
import ukjobspecialisms from "../../.sourceflow/jobs-Specialisms.json";

import {
    Container,
    Col,
    Row
} from 'reactstrap';
import styles from './styles.module.scss';
import Link from "next/link"
import React from "react";
import JobSearch from "@sourceflow-uk/job-search";
import "@sourceflow-uk/job-search/dist/bundle.css";
import JobsCard from "/components/JobsCard";

export default function AllJobSearch({
    global,
    pathPrefix,
    customClass = "",
    sectorIds,
    internalJob = false,
    jobClientFilter = false,
    locale = "",
    newsletter_content,
    formId,
    successPageUrl,
    client_cat_value,
    us_jobs = false,
    sectionID
}) {
    return (
        <>
            <section className={`${styles.root} ${customClass} ${internalJob ? "internal-jobs" : ""}`} id={`${sectionID}`}>
                <Container>
                    {internalJob ?
                        <JobSearch
                            translations={{
                                "button.text": "Search",
                                "input.placeHolder": "Search by location/job title",
                                "input.locationPlaceholder": "Location",
                            }}
                            options={{
                                jobsPerPage: 12,
                                searchFilters: true,
                                submitDestination: null,
                                performInitialSearch: true,
                                searchSubmitButton: true,
                                searchInput: {
                                    queryInput: true,
                                    locationInput: false,
                                    radiusInput: false,
                                    radiusOptions: {
                                        units: "kilometres"
                                    }
                                },
                                prefilters: {
                                    "ee19575c-07f3-4869-8ef1-f90262ae380e": [
                                        "cb399e32-08f6-47b7-af8b-65a8b52c2c8b"
                                    ]
                                },
                                searchFiltersOptions: {
                                    topLevelCategoryOrder: ["Sectors", "Salary", "Job Type"], // filters will appear in this order
                                    filterShowCount: false,
                                    // filterSelectedElement: <div className={`option selected`} />,
                                    // filterUnselectedElement: <div className={`option unselected`} />,
                                    exclude: {
                                        // Internal Job
                                        'ee19575c-07f3-4869-8ef1-f90262ae380e': true,
                                        // Base Salary Range
                                        // '1d3acfb7-a4ae-4113-ab31-7489b1b21d9a': true,
                                        // Job Type
                                        // '8605e8ca-62e6-4bdb-9f0e-23fb95f26e49': true,
                                        // Consultants
                                        Consultants: true,
                                        Country: true,
                                        '3d5bec36-c55b-4f99-a149-d5931658df26': true,
                                        'f46a3886-58ed-463b-83ab-7e682fee8ee6': true,
                                        // Sector: sector
                                        // Sector: ["Recruitment"]
                                        'aafb10c9-becd-46d7-8a0b-a1e02ba59f03': locale === "/us" ? false : true
                                    }
                                },
                                searchResults: ({ results }) =>
                                    results?.length >= 1 ?
                                        <>
                                            <Row>
                                                {results.map(({ job, index }) => (
                                                    <Col lg={6} xl={4} key={index} className="mb-4">
                                                        <JobsCard
                                                            post_lang={locale}
                                                            {...job} />
                                                    </Col>
                                                ))}
                                            </Row>
                                        </>
                                        : <><p>Sorry, we couldn't find any jobs matching your search. Please try removing some filters or searching for something else.</p></>
                            }
                            }
                        />
                        :
                        jobClientFilter ?
                            <JobSearch
                                translations={{
                                    "button.text": "Search",
                                    "input.placeHolder": "Search by location/job title",
                                    "input.locationPlaceholder": "Location",
                                }}
                                options={{
                                    urlFilters: {
                                        mode: "active",
                                        jobCategories: [jobsSector, ukjobsType, usjobsType, jobsCountry, ukjobsWorkType, usjobsWorkType, ukbasesalaryrange, ukjobspecialisms],
                                        pushToHistoryOnSearch: true,
                                        changeURLOnFilterChange: true,
                                    },
                                    jobsUrl: `${locale === "/us" ? "/us" : ""}/jobs`,
                                    jobsPerPage: 9,
                                    searchFilters: false,
                                    submitDestination: null,
                                    performInitialSearch: true,
                                    searchSubmitButton: false,
                                    searchInput: {
                                        queryInput: false,
                                        locationInput: false,
                                        radiusInput: false,
                                        radiusOptions: {
                                            units: "kilometres"
                                        }
                                    },
                                    prefilters: {
                                        //Filter jobs not in internal
                                        '269c3235-90e5-44d8-8c69-bdb0c043f331':
                                            [`${client_cat_value}`],
                                        '7710db30-b4cf-4029-b846-e02e2f0c9b3b':
                                            [`${us_jobs ? `3a9d7b47-ea19-464e-8fbf-d52571b038cb` : `73aeaf93-9fd9-4947-bfd8-4ce08ce31d01`}`],
                                    },
                                    searchFiltersOptions: {
                                        showResetSearchButton: true,
                                        // topLevelCategoryOrder: ["Expertise", "Salary", "Work Type"], // filters will appear in this order
                                        filterShowCount: true,
                                        // filterSelectedElement: <div className={`option selected`} />,
                                        // filterUnselectedElement: <div className={`option unselected`} />,
                                        exclude: {
                                            // Internal Job
                                            // 'ee19575c-07f3-4869-8ef1-f90262ae380e': true,
                                            // Country: true,
                                            // Base Salary Range
                                            // '1d3acfb7-a4ae-4113-ab31-7489b1b21d9a': true,
                                            // Job Type
                                            // '8605e8ca-62e6-4bdb-9f0e-23fb95f26e49': true,
                                            // Consultants
                                            // Consultants: true,
                                            // Sector: sector
                                            'aafb10c9-becd-46d7-8a0b-a1e02ba59f03': locale === "/us" ? false : true
                                        }
                                    },
                                    searchResults: ({ results }) =>
                                        results?.length >= 1 ?
                                            <>
                                                <Row>
                                                    {results.map(({ job, index }) => (
                                                        <Col lg={6} xl={4} key={index} className="mb-4">
                                                            <JobsCard
                                                                post_lang={locale}
                                                                {...job} />
                                                        </Col>
                                                    ))}
                                                </Row>
                                            </>
                                            : <><p>Sorry, we couldn't find any jobs matching your search. Please try removing some filters or searching for something else.</p></>
                                }
                                }
                            /> :
                            <JobSearch
                                translations={{
                                    "button.text": "Search Jobs",
                                    "input.placeHolder": "Job Title or Keyword",
                                    "input.locationPlaceholder": "enter location",
                                    // "searchResults.resultsTotalCount": 'We have {{count}} matching jobs for you!'
                                }}
                                options={{
                                    urlFilters: {
                                        mode: "active",
                                        jobCategories: [jobsSector, ukjobsType, usjobsType, jobsCountry, ukjobsWorkType, usjobsWorkType, ukbasesalaryrange, usbasesalaryrange, ukjobspecialisms],
                                        pushToHistoryOnSearch: true,
                                        changeURLOnFilterChange: true,
                                    },
                                    jobsUrl: `${locale === "/us" ? "/us" : ""}/jobs`,
                                    jobsPerPage: 9,
                                    searchFilters: true,
                                    submitDestination: null,
                                    performInitialSearch: true,
                                    searchSubmitButton: true,
                                    searchInput: {
                                        queryInput: true,
                                        locationInput: false,
                                        radiusInput: false,
                                        radiusOptions: {
                                            units: "kilometres"
                                        }
                                    },
                                    prefilters: {
                                        //Filter jobs not in internal
                                        // '98f7f0ee-bfd3-491f-b8b9-9e9c8528d18a': sectorIds,
                                        '7710db30-b4cf-4029-b846-e02e2f0c9b3b': sectorIds,
                                    },
                                    searchFiltersOptions: {
                                        showResetSearchButton: true,
                                        topLevelCategoryOrder: ["Expertise", "Salary", "Work Type"], // filters will appear in this order
                                        filterShowCount: true,
                                        // filterSelectedElement: <div className={`option selected`} />,
                                        // filterUnselectedElement: <div className={`option unselected`} />,
                                        exclude: {
                                            // Internal Job
                                            // '50d8c35a-f5bd-4617-8c9f-b316236d7dc9': true,
                                            // Country: true,
                                            // Base Salary Range
                                            // '1d3acfb7-a4ae-4113-ab31-7489b1b21d9a': true,
                                            // Job Type
                                            // '8605e8ca-62e6-4bdb-9f0e-23fb95f26e49': true,
                                            // Consultants
                                            Consultants: true,
                                            // Sector: sector
                                            // Sector: ["Recruitment"]
                                            'aafb10c9-becd-46d7-8a0b-a1e02ba59f03': locale === "/us" ? false : true
                                        },
                                        categorySort: {
                                            // "Specialist Focus": { key: "order", direction: "desc" },
                                            Expertise: { key: "name", direction: "asc" },
                                            // Job Type
                                            "94f5cb95-97ee-4c71-97ff-ed79514cabff": { key: "name", direction: "asc" },
                                            "US Base Salary Range": function (a, b) {
                                                const matchA = a.name.match(/\$([\d,]+)(?:-\d+k)?/);
                                                const matchB = b.name.match(/\$([\d,]+)(?:-\d+k)?/);
                                                if (!matchA || !matchB) {
                                                    console.error("Invalid salary format:", a.name, b.name);
                                                    return 0; 
                                                }
                                                a = parseInt(matchA[1].replace(/,/g, ""), 10);
                                                b = parseInt(matchB[1].replace(/,/g, ""), 10);

                                                return a - b; 
                                            },
                                            'UK Base Salary Range': function (a, b) {
                                                a = parseInt(a.name.match(/^£([\d,]+)/)[1].replace(",", ""));
                                                b = parseInt(b.name.match(/^£([\d,]+)/)[1].replace(",", ""));

                                                if (a > b) return 1;
                                                if (a < b) return -1;
                                                return 0;
                                            },
                                            // Job: { key: "name", direction: "asc" },
                                            // "98f7f0ee-bfd3-491f-b8b9-9e9c8528d18a": {
                                            //     key: "id",
                                            //     direction: "desc",
                                            // },
                                            // "98f7f0ee-bfd3-491f-b8b9-9e9c8528d18a": function (a, b) {
                                            //     console.log(a, b);
                                            //     // const all_a = a.orderBy('order');
                                            //     // return all_a;

                                            // },
                                            
                                        },
                                    },
                                    searchResults: ({ results }) =>
                                        results?.length >= 1 ?
                                            <>
                                                <Row>
                                                    {results.map(({ job, index }) => (
                                                        <Col xs={12} md={6} lg={4} key={index} className="mb-3">
                                                            <JobsCard
                                                                post_lang={locale}
                                                                {...job} />
                                                        </Col>
                                                    ))}
                                                </Row>
                                            </>
                                            : <><p>Sorry, we couldn't find any jobs matching your search. Please try removing some filters or searching for something else.</p></>
                                }
                                }
                            />
                    }
                    <div className="newsletter mt-5">
                        <div className="columnWrapper p-4 rounded-4">
                            {newsletter_content ?
                                <div className="mb-5">
                                    <SourceFlowText global={global} path={`${pathPrefix}.newsletter_content`} type="html">
                                        {newsletter_content}
                                    </SourceFlowText>
                                </div>
                                : null}
                            {formId ?
                                <SourceFlowForm
                                    formId={formId}
                                    onSubmitDone={() => (window.location.href = successPageUrl)}
                                /> : ""}
                        </div>
                    </div>
                </Container>
            </section>
        </>
    )
}